import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
import analyticsImg from "../../assets/img/email-analytics.png"
const ActionAnalytics = ({to,onClick, children}) => {
  return (
    <Link
      to={to}
      className={`btn btn-edit`}
      onClick={onClick}
    >
     <img src={analyticsImg} style={{width:20}} /> {children}
    </Link>
  );
};

ActionAnalytics.propTypes = {
to:PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
};
ActionAnalytics.defaultProps = {
    to:'#',
    onClick: () => {},
    children:''
  };
export default ActionAnalytics;
